import React from "react";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";

const stats = [
  {
    value: "1,213",
    label: "Total Gold Reserves",
    change: "31% from last month",
    direction: "up",
    img: "/images/Dashboard/card11.svg",
    color: "bg-[#F9F4E8] border-[#D3B25B]",
    changeColor: "text-green-600"
  },
  {
    value: "1,213",
    label: "Tokens in circulation",
    change: "5.7 from last month",
    direction: "up",
    img: "/images/Dashboard/card22.svg",
    color: "bg-[#F7FBFF] border-[#54A5F5] text-black",
    changeColor: "text-green-600"
  },
  {
    value: "1,213",
    label: "Pending Transactions",
    change: "12% from yesterday • New requests",
    direction: "down",
    img: "/images/Dashboard/card33.svg",
    color: "bg-[#F4F0ED] border-[#A4724C] text-red-800",
    changeColor: "text-red-600"
  },
  {
    value: "1,213",
    label: "Compliance Issues",
    change: "2 less than yesterday",
    direction: "up",
    img: "/images/Dashboard/card44.svg",
    color: "bg-[#DCF0DC] border-[#2CA62D] text-black",
    changeColor: "text-green-600"
  }
];

export default function StatsCards() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
      {stats.map((stat, idx) => (
        <div
          key={idx}
          className={`border rounded-xl p-2 px-4 flex flex-col gap-2 ${stat.color}`}
        >
          <div className="flex justify-between items-center">
            <div className="font-poppins font-semibold text-[27px] leading-6 text-black">
              {stat.value}
            </div>
            <img
              src={stat.img}
              alt=""
              className={`border p-2 rounded-full !bg-white ${stat.color}`}
            />
          </div>
          <div className="font-poppins font-medium text-[16px] leading-4 text-[#8D8D8D]">
            {stat.label}
          </div>
          <div
            className={`flex items-center gap-1 font-poppins font-semibold text-[16px] leading-6 ${stat.changeColor}`}
          >
            {stat.direction === "up" ? (
              <FaArrowUp className="text-lg" />
            ) : (
              <FaArrowDown className="text-lg" />
            )}
            <span className="text-black"> {stat.change} </span>
          </div>
        </div>
      ))}
    </div>
  );
}
